<ng-container [formGroup]="model">
    @switch (field.input.type) {
        @case (inputType.DROPDOWN) {
            <p-select
                #reactiveSelect
                *ngIf="isEditable; else readOnly"
                [inputId]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                optionLabel="label"
                optionValue="value"
                [dataKey]="dataKey ?? ''"
                [placeholder]="getSelectPlaceholder()"
                [options]="renderedOptions"
                styleClass="reactive-form-select w-100"
                [style]="{ width: '100%' }"
                [attr.aria-invalid]="isInvalid"
                (onHide)="onPanelHide()"
                (onShow)="onPanelShow()">
            </p-select>
        }

        @case (inputType.DROPDOWN_SEARCH) {
            <p-select
                #reactiveSelect
                *ngIf="isEditable; else readOnly"
                [inputId]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                [options]="renderedOptions"
                optionLabel="label"
                optionValue="value"
                [dataKey]="dataKey ?? ''"
                [filter]="true"
                [placeholder]="getSelectPlaceholder()"
                [virtualScroll]="virtualScrollEnabled"
                [virtualScrollItemSize]="virtualScrollItemSize"
                filterBy="label"
                styleClass="reactive-form-select w-100"
                [style]="{ width: '100%' }"
                [attr.aria-invalid]="isInvalid"
                (onHide)="onPanelHide()"
                (onShow)="onPanelShow()"
                (onFilter)="onFilter($event)">
            </p-select>
        }

        @case (inputType.MULTISELECT) {
            <p-listbox
                *ngIf="isEditable; else readOnly"
                [options]="renderedOptions"
                [filter]="filterInputParcelas"
                [metaKeySelection]="false"
                [checkbox]="true"
                [multiple]="true"
                [showToggleAll]="false"
                [dataKey]="dataKey ?? ''"
                [listStyle]="{
                    'max-height': field.input.dropdownConfiguration?.hasMaxHeight ? '100%' : '15rem',
                    'min-height':'18px',
                    'width': '100%'
                }"
                styleClass="reactive-form-select w-100"
                [attr.aria-describedby]="describedById || null"
                [formControlName]="field.name"
                [attr.aria-invalid]="isInvalid">
            </p-listbox>
        }

        @case (inputType.MULTISELECT_SEARCH) {
            <p-multiselect
                #reactiveMultiselect
                *ngIf="isEditable; else readOnly"
                [options]="renderedOptions"
                [inputId]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                [placeholder]="getSelectPlaceholder()"
                [virtualScroll]="virtualScrollEnabled"
                [virtualScrollItemSize]="virtualScrollItemSize"
                filterBy="label"
                [showToggleAll]="true"
                [resetFilterOnHide]="false"
                [dataKey]="dataKey ?? ''"
                (onPanelShow)="onPanelShow()"
                (onPanelHide)="onPanelHide()"
                (onFilter)="onFilter($event)"
                styleClass="reactive-form-select w-100"
                [style]="{ width: '100%' }"
                [maxSelectedLabels]="2"
                [attr.aria-invalid]="isInvalid">
                <ng-template let-data #item>
                    <div class="multiselect-option-label">
                        {{ data.label }}
                    </div>
                </ng-template>
            </p-multiselect>
        }

        @case (inputType.SELECT_BUTTON) {
            <p-selectButton
                (onOptionClick)="updateModel()"
                [attr.aria-describedby]="describedById || null"
                [options]="renderedOptions"
                [multiple]="field.input.selectButtonConfiguration?.isMultiSelect"
                styleClass="reactive-form-select w-100"
                [disabled]="field.input.selectButtonConfiguration?.isDisabled ?? false"
                [attr.aria-invalid]="isInvalid">
            </p-selectButton>
        }
    }
</ng-container>

<ng-template #readOnly>
    <app-reactive-read-only-field [field]="field" [model]="model"></app-reactive-read-only-field>
</ng-template>
